import AbstractHover from './abstractHover';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import StepOne from './selectedSeats/stepOne';
import StepTwo from './selectedSeats/stepTwo';
import Wizard from '../wizard';
import { NullContingent } from '../../models/contingent';
import { Icon } from '@weezevent/nacre';

class SelectedSeats extends AbstractHover {
    static propTypes = {
        assignContingent: PropTypes.func.isRequired,
        contingents: PropTypes.object.isRequired,
        currentInventory: PropTypes.object.isRequired,
        zone: PropTypes.object.isRequired,
        mouseX: PropTypes.number.isRequired,
        mouseY: PropTypes.number.isRequired,
        seats: PropTypes.array.isRequired,
        unselectSeats: PropTypes.func.isRequired
    };

    constructor(...args) {
        super(...args);

        const currentContingent = this.props.contingents[this.props.seats[0].contingent] || new NullContingent();

        this.state = {
            currentContingent,
            selectedContingent: currentContingent
        };
    }

    selectContingent(selectedContingent) {
        this.setState({ selectedContingent });
    }

    unselectSeats() {
        this.props.unselectSeats();
    }

    assignContingent() {
        this.unselectSeats();
        this.props.assignContingent(this.state.selectedContingent, this.props.seats);
    }

    unassignContingent() {
        this.unselectSeats();
        this.props.assignContingent(null, this.props.seats);
    }

    className() {
        return 'seat-selection';
    }

    draggableProps() {
        return {
            handle: '.handle',
            static: true
        };
    }

    renderTitle() {
        return (
            <span className="actions">
                <Icon name="cross" className={'action danger'} onClick={this.unselectSeats.bind(this)} />
            </span>
        );
    }

    renderContent() {
        const { contingents, currentInventory, zone, rate, seats } = this.props;
        let { selectedContingent } = this.state;

        let allSeatsUnavailable = seats.every(seat => seat.contingent === null);
        let canChangeContingent = seats.every(seat => seat.booking_state !== 'BOOKED' && seat.booking_state !== 'BOOKING_IN_PROGRESS');

        const steps = [
            {
                // eslint-disable-next-line react/display-name
                name: () => (
                    <Trans count={seats.length} values={{ seatsCount: seats.length }} i18nKey="seats_selected">
                        %seatsCount% seat selected
                    </Trans>
                ),
                component: (
                    <StepOne
                        key="step-one"
                        contingents={contingents}
                        seats={this.props.seats}
                        canUnassignContingent={canChangeContingent && !allSeatsUnavailable}
                        unassignContingent={this.unassignContingent.bind(this)}
                    />
                ),
                next: <Trans i18nKey="seats_selection_change_contingent_action">Change contingent</Trans>,
                hasNext: canChangeContingent
            }
        ];

        if (canChangeContingent) {
            steps.push({
                name: <Trans i18nKey="contingent.selected_new">Select a new contingent</Trans>,
                component: (
                    <StepTwo
                        key="step-two"
                        contingents={contingents}
                        currentInventory={currentInventory}
                        rate={{ rates: rate }}
                        seats={seats}
                        selectContingent={this.selectContingent.bind(this)}
                        selectedContingent={selectedContingent}
                        zone={zone}
                    />
                )
            });
        }

        return <Wizard canGoBack={false} onSubmit={this.assignContingent.bind(this)} showFooter={canChangeContingent} steps={steps} />;
    }
}

export default SelectedSeats;
